import React, { createContext, useContext } from 'react';

/**
 * use this type to extend interfaces of class
 */
import { jsx as _jsx } from "react/jsx-runtime";
const WizardContext = /*#__PURE__*/createContext(null);
export function useWizard() {
  const ctx = useContext(WizardContext);
  if (!ctx) {
    throw new Error('[useWizard/Wizard] tried to use useWizard outside of a Wizard');
  }
  return ctx;
}
export const WizardContextProvider = ({
  children,
  currentStep,
  steps,
  setStep,
  onStepChange
}) => {
  const value = {
    currentStep,
    steps,
    setStep: nextStep => {
      if (onStepChange) {
        onStepChange({
          currentStep,
          nextStep
        });
      }
      setStep(nextStep);
    }
  };
  return /*#__PURE__*/_jsx(WizardContext.Provider, {
    value: value,
    children: children
  });
};